<template>
	<div class="ProgrammeDetails">
		<h2
			v-skeleton="{
				loading,
				sizes: {
					Small: { width: '100%', height: '1.5rem' },
					Large: { width: '100%', height: '1.75rem' },
					ExtraLarge: { width: '29.25rem', height: '1.75rem' },
				}
			}"
			class="Title"
		>
			{{ programmeTitle }}
		</h2>
		<InlineSummary
			v-skeleton="{
				loading,
				sizes: {
					Small: { width: '100%', height: '1.5rem' },
					Large: { width: '100%', height: '1.75rem' },
					ExtraLarge: { width: '27.75rem', height: '1.75rem' },
				}
			}"
			:summary="summary"
		/>
	</div>
</template>

<script setup lang="ts">
import InlineSummary from '@components/InlineSummary/InlineSummary.vue';

const props = defineProps({
	programmeTitle: {
		type: String,
		default: '',
	},
	summary: {
		type: String,
		default: '',
	},
	loading: {
		type: Boolean,
		default: false,
	},
});
</script>

<style scoped lang="scss">
	.ProgrammeDetails {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
		width: 100%;

		@include MarginAreas(0.5, 0, 0, 0);

		.Title {
			display: -webkit-box;
			-webkit-box-orient: vertical;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: normal;
			-webkit-line-clamp: 2;
			line-clamp: 2;
			color: $Grey-900;

			@include TextStyle(HeadingSmall);
			@include MarginAreas(0);

			@include Breakpoint(Large, ExtraLarge) {
				-webkit-line-clamp: 3;
				line-clamp: 3;
			}
		}
	}
</style>
